import React, { useState } from 'react';
import { Box } from '@mui/material';

import { SimpleButton, CheckIcon } from '@/src/ui';

type LegendPillProps = { children: React.ReactNode };
const LegendPill = ({ children }: LegendPillProps) => (
    <span
        style={{
            background: '#f7f7f7',
            border: '1px solid #e1e1e1',
            borderRadius: 12,
            padding: '2px 8px',
            fontWeight: 600,
            fontSize: 13,
            display: 'inline-block',
            minWidth: 24,
            textAlign: 'center',
        }}
    >
        {children}
    </span>
);

type SubmissionHistoryLegendProps = {
    dataLoaded: boolean;
};

const SubmissionHistoryLegend: React.FC<SubmissionHistoryLegendProps> = (props) => {
    const { dataLoaded } = props;
    const [showLegend, setShowLegend] = useState(false);

    if (!dataLoaded) return null;

    return (
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <SimpleButton
                variant="outlined"
                onClick={() => setShowLegend((prev) => !prev)}
                aria-expanded={showLegend}
                aria-label="Toggle legend dropdown"
            >
                {showLegend ? 'Hide Legend' : 'Show Legend'}
            </SimpleButton>
            {showLegend && (
                <Box
                    sx={{
                        top: '100%',
                        left: 0,
                        zIndex: 10,
                        mt: 1,
                        border: '1px solid #e5e7eb',
                        borderRadius: 2,
                        p: 1.5,
                        bgcolor: '#fff',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                        fontSize: 14,
                        color: '#555',
                        width: 'fit-content',
                        maxWidth: 700,
                    }}
                    aria-label="Status legend"
                >
                    {/* Statuses */}
                    <Box sx={{ fontWeight: 700, fontSize: 13, color: '#333', mb: 0.75 }}>
                        Statuses
                    </Box>
                    <Box
                        sx={{
                            // match the question types layout
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            columnGap: 3,
                            rowGap: 1,
                            mb: 1.5,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>INC</LegendPill>
                            <span>Incomplete</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>HS</LegendPill>
                            <span>Needs Handscore</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>
                                <CheckIcon color="green" />
                            </LegendPill>
                            <span>Complete</span>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default SubmissionHistoryLegend;
